import React from 'react'
import { StyleSheet, View } from 'react-native'
import { colors } from '@lib/colors'
import Navbar from '@components/Navbar'
import { StatusBar } from 'expo-status-bar'
import useNavigation from '@hooks/useNavigation'

interface LayoutProps {
  children: JSX.Element | JSX.Element[]
  hideBackButton?: boolean
  onNavigateBack?: () => void
}

export default function ({ children, hideBackButton, onNavigateBack }: LayoutProps) {
  const navigation = useNavigation()

  let goBack
  if (!hideBackButton) {
    goBack = () => {
      if (onNavigateBack) onNavigateBack()
      navigation.goBack()
    }
  }

  return (
    <>
      <Navbar goBack={ goBack } />
      <View style={styles.container}>
        { children }
      </View>
      <StatusBar style="auto" />
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.gray['50'],
  },
})
